import store from '../../redux/store';
import {selectPlayers} from '../../redux/reducers/sharedStateReducer/selectors';
import {REACTION_RECIPIENT_ALL, REACTION_TYPES} from '../../configs/reactions';
import {getRandomElement} from '../other/getRandomElement';
import {getRandomDelayMs} from '../other/getRandomDelayMs';
import {sendBotReaction} from './sendBotReaction';
import {checkIfBotSendsReactions} from './checkIfBotSendsReactions';

const BOT_REPLY_CHANCE = 0.4;
const BOT_REPLY_MIN_DELAY_MS = 5 * 1000;
const BOT_REPLY_MAX_DELAY_MS = 30 * 1000;

// Ответная реакция бота — общая для реакции, отправленной РЕАЛЬНЫМ игроком
// (ReactionsPanel), и реакции, отправленной ДРУГИМ БОТОМ (BotReactionsSimulator:
// повторяющийся цикл и приветствие). С вероятностью 40% через случайные
// 10-30 секунд: адресован конкретный бот — отвечает он сам; адресовано
// «Всем» — случайный бот матча (не считая исходного отправителя, если он
// сам бот — чтобы бот не «отвечал сам себе»); адресован конкретный НЕ-бот
// игрок — ответа не будет вовсе. Тип реакции случайный, ответ адресуется
// обратно исходному отправителю.
//
// Рекурсивно: у только что отправленного ответа тоже есть свой шанс 40%
// получить ответ — переписка бот<->бот способна на пару обменов подряд, но
// не убегает (геометрическая прогрессия, ожидаемая длина цепочки конечна).
//
// isCancelled — вызывающая сторона обязана передать проверку на то, что ее
// собственный компонент еще смонтирован. Цепочку от начала до конца ведет
// ИСКЛЮЧИТЕЛЬНО тот клиент, чей таймер отправил самую первую реакцию —
// остальные клиенты получают ее через REACTION_RECEIVED пассивно и НЕ
// запускают по ней собственную цепочку (иначе один и тот же ответ
// дублировался бы каждым подключенным клиентом)
export const scheduleBotReply = (lobbyId, toPlayerId, fromPlayerId, isCancelled = () => false) => {
  if (Math.random() >= BOT_REPLY_CHANCE) {
    return;
  }
  setTimeout(() => {
    if (isCancelled()) {
      return;
    }
    const players = selectPlayers(store.getState());
    // «Явный» бот не отвечает так же, как не пишет первым (см.
    // checkIfBotSendsReactions) — адресованная ему реакция остается без ответа
    const replyingBot = toPlayerId === REACTION_RECIPIENT_ALL
      ? getRandomElement(players.filter((player) => checkIfBotSendsReactions(player) && player.id !== fromPlayerId))
      : players.find((player) => player.id === toPlayerId && checkIfBotSendsReactions(player) && player.id !== fromPlayerId);
    if (!replyingBot) {
      return;
    }
    sendBotReaction(lobbyId, replyingBot.id, fromPlayerId, getRandomElement(REACTION_TYPES).id);
    scheduleBotReply(lobbyId, fromPlayerId, replyingBot.id, isCancelled);
  }, getRandomDelayMs(BOT_REPLY_MIN_DELAY_MS, BOT_REPLY_MAX_DELAY_MS));
};
